"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contracts = void 0;
exports.contracts = {
    250: ['0x14Ffd1Fa75491595c6FD22De8218738525892101', 'https://rpc.ftm.tools'],
    '0xFA': ['0x14Ffd1Fa75491595c6FD22De8218738525892101', 'https://rpc.ftm.tools'],
    Fantom: ['0x14Ffd1Fa75491595c6FD22De8218738525892101', 'https://rpc.ftm.tools'],
    FTM: ['0x14Ffd1Fa75491595c6FD22De8218738525892101', 'https://rpc.ftm.tools'],
};
